import { FC } from "react";
import { useNavigate } from "react-router-dom";

import { IModalProps } from "config/init/providers/ModalsProvider";
import { usePop } from "containers/DynamicForm/useButtonCommand/usePop";
import { Layout, useTranslation } from "modules";

const NoPIUChangeErrorModal: FC<IModalProps> = ({ closeModal }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const popCommand = usePop();

  const onClickCancelRequest = async () => {
    try {
      closeModal();
      await popCommand([], {});
    } catch (error) {
      navigate(-1);
    }
  };

  const content = {
    alwaysShowIcon: true,
    button: [
      {
        text: t("piu.no_change_error.modal.cta.return", "RETURN & MAKE CHANGES"),
        onClick: () => closeModal(),
      },
      {
        text: t("piu.no_change_error.modal.cta.cancel", "CANCEL REQUEST"),
        subType: "text-dark",
        onClick: onClickCancelRequest,
      },
    ],
    icon: "BlobTurtleError",
    header: t("piu.no_change_error.modal.header", "Sorry, your information was not changed"),
    subheader: t(
      "piu.no_change_error.modal.subheader",
      "It looks like you’ve added documents, but did not make any changes to your information.\n\nIf you cancel your change request, your documents will not be sent to Wysh."
    ),
  };

  return <Layout as="ModalLayout" className="left-align-sm" content={content} />;
};

export default NoPIUChangeErrorModal;
